import React, { useState, useEffect } from "react";
import "../css/signup.css";
import queryString from "query-string";
import { useLocation } from "react-router";

interface VerifyEmailState {
  error: string;
  data: {
    message: string;
    isSuccessful?: boolean;
  };
}

interface VerifyQuery {
  email: string | (string | null)[] | null;
  code: string | (string | null)[] | null;
  tenantId: string | (string | null)[] | null;
  planId: string | (string | null)[] | null;
}

const VerifyEmail = (): React.ReactElement => {
  const location = useLocation();
  const [state, setState] = useState<VerifyEmailState>({
    error: "",
    data: { message: "Please wait while verifying your details." },
  });

  const verifyEmail = (query: VerifyQuery): void => {
    setState((prev) => ({ ...prev, error: "" }));

    fetch(import.meta.env.VITE_API_BASE_URL + "/api/user/verify", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(query),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.isSuccessful) {
            setState({
              error: "",
              data: { isSuccessful: true, message: "Email verified successfully. Redirecting..." },
            });
            setTimeout(function () {
              window.location.replace("/");
            }, 2000);
          } else {
            setState({
              error: "",
              data: { isSuccessful: false, message: "Verification failed." },
            });
          }
        },
        (error) => {
          setState({ error: "Something went wrong please try again.", data: { message: "" } });
          console.log(error);
        },
      );
  };

  useEffect(() => {
    const values = queryString.parse(location.search);
    const query: VerifyQuery = {
      email: values.email,
      code: values.code,
      tenantId: values.tenantId,
      planId: values.planid,
    };

    if (!query.email || !query.code || !query.tenantId || !query.planId) {
      setState({ error: "Invalid request please check your email.", data: { message: "" } });
    } else {
      verifyEmail(query);
    }
  }, [location.search]);

  return (
    <div
      className="form-box"
      id="login-box"
    >
      <div className="header">Skypoint ICDP</div>
      <div className="body bg-white left-0">
        {state.error ? (
          <h4 className="text-warning">{state.error}</h4>
        ) : (
          <h4 className={state.data.isSuccessful ? "text-success" : "text-warning"}>
            {state.data.message}
          </h4>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
